module.exports = __webpack_public_path__ + "img/202407_01_sp.f6765455.jpg";